import React, { useCallback } from 'react'

import { getIn } from 'formik'

import ItemForm from '../../../../ItemForm'
import StoriesFormFields from '../../StoriesFormFields'

import { keys } from '../../../../../../../../../../helpers/common'

import {
  IS_ITEM_FORM_OPENED,
  STORIES_ITEM_MEDIA_FILE_ERROR,
  STORIES_ITEM_SELECTED_INDEX,
  STORIES_ITEMS
} from '../../../../../../../fields'

const StoriesCarouselItem = ({
  formik,
  index,
  onItemDelete,
  onItemClick,
  showError,
  isStepFieldsValid,
  storiesItemFormTitle
}) => {
  const { values, setFieldValue, errors, touched } = formik

  const itemPath = `${STORIES_ITEMS}[${index}]`

  const storiesItems = getIn(values, `${STORIES_ITEMS}`)
  const selectedItemIndex = getIn(values, `${STORIES_ITEM_SELECTED_INDEX}`)

  const itemErrors = getIn(errors, itemPath)
  const itemTouched = getIn(touched, itemPath)
  const isItemActive = selectedItemIndex === index

  const isRemovable = storiesItems.length > 1

  const isFocused = getIn(values, `${IS_ITEM_FORM_OPENED}`)
  const isOpened = isFocused && isItemActive

  const isValid = itemErrors && itemTouched && isStepFieldsValid(itemErrors, keys(itemTouched))

  const mediaFileError = getIn(values, `${itemPath}.${STORIES_ITEM_MEDIA_FILE_ERROR}`)

  const handleDeleteStoriesItem = useCallback(() => {
    onItemDelete(index)
  }, [index, onItemDelete])

  const closeFormHandler = useCallback(() => {
    setFieldValue(IS_ITEM_FORM_OPENED, false)
  }, [setFieldValue])

  const selectStoriesForm = useCallback(() => {
    onItemClick({ index, isFormOpened: true })
  }, [onItemClick, index])

  return (
    <ItemForm
      isValid={isValid}
      isOpened={isOpened}
      isItemActive={isItemActive}
      mediaFileError={mediaFileError}
      index={index}
      isRemovable={isRemovable}
      selectForm={selectStoriesForm}
      closeForm={closeFormHandler}
      deleteItem={handleDeleteStoriesItem}
      itemFormTitle={storiesItemFormTitle}
    >
      <StoriesFormFields
        index={index}
        isItemActive={isItemActive}
        isStepFieldsValid={isStepFieldsValid}
        formik={formik}
        showError={showError}
      />
    </ItemForm>
  )
}

export default StoriesCarouselItem
